import { apis } from '../apiBase/apiBase';
const announcementApis = apis.injectEndpoints({
    endpoints: (builder) => ({
        getAnnouncements: builder.query({
            query: (params) => ({
                url: `announcements`,
                method: 'GET',
                params,
            }),
        }),
        getAnnouncementUnreadCount: builder.query({
            query: () => ({
                url: `announcements/unread-count`,
                method: 'GET',
            }),
        }),
        markAllRead: builder.mutation({
            query: () => ({
                url: 'announcements/mark-all-read',
                method: 'POST',
            }),
        }),
        updateAnnouncementRead: builder.mutation({
            query: (params) => ({
                url: `announcements/update-read`,
                method: 'POST',
                body: params,
            }),
        }),
    }),
    overrideExisting: false,
});
export const { useGetAnnouncementsQuery, useLazyGetAnnouncementsQuery, useGetAnnouncementUnreadCountQuery, useLazyGetAnnouncementUnreadCountQuery, useMarkAllReadMutation, useUpdateAnnouncementReadMutation, } = announcementApis;
